/*
  UGC video grid — Modalia
  Click a card to play it inline with sound. Only one video plays at a time:
  starting one resets the others back to their poster. Pausing with the native
  controls keeps the current frame, so the poster only comes back on end.
*/

class UgcVideoGrid extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));

    this.querySelectorAll('video').forEach((video) => {
      video.addEventListener('ended', () => this.resetCard(video));
    });
  }

  handleClick(event) {
    const trigger = event.target.closest('[data-ugc-play]');
    if (!trigger) return;

    const card = trigger.closest('[data-ugc-card]');
    const video = card && card.querySelector('video');
    if (!video) return;

    this.resetOthers(video);

    card.classList.add('ugc-videos__card--playing');
    video.controls = true;
    video.muted = false;

    const played = video.play();
    if (played) {
      played.catch(() => this.resetCard(video));
    }
  }

  resetOthers(current) {
    this.querySelectorAll('video').forEach((video) => {
      if (video === current) return;
      video.pause();
      this.resetCard(video);
    });
  }

  resetCard(video) {
    const card = video.closest('[data-ugc-card]');
    if (!card) return;

    card.classList.remove('ugc-videos__card--playing');
    video.controls = false;
    video.currentTime = 0;
  }
}

customElements.define('ugc-video-grid', UgcVideoGrid);
